import { CENTRAL, COMMON, ifyouApi } from 'apis/config';

export const packageApi = {
  read: () =>
    ifyouApi
      .post(`${CENTRAL}`, {
        func: 'requestPackageList',
        lang: 'KO',
      })
      .then((res) => res.data),

  register: ({ inputData }) =>
    ifyouApi
      .post(`${CENTRAL}`, {
        func: 'createNewPackage',
        lang: 'KO',
        package_name: inputData.package_name,
        package_summary: inputData.package_summary,
        project_id: inputData.project_id,
      })
      .then((res) => res.data),
  update: ({ detailData }) =>
    ifyouApi
      .post(`${CENTRAL}`, {
        func: 'updatePackage',
        package_name: detailData.package_name,
        package_summary: detailData.package_summary,
        project_id: detailData.project_id,
        package_id: detailData.package_id,
      })
      .then((res) => res.data),
  serverUpdate: ({ detailData }) =>
    ifyouApi
      .post(`${CENTRAL}`, {
        func: 'updatePackageServer',
        package_id: detailData.package_id,
        test_server_url: detailData.test_server_url,
        review_server_url: detailData.review_server_url,
        live_server_url: detailData.live_server_url,
      })
      .then((res) => res.data),
};

export const clientApi = {
  read: (package_id: string) =>
    ifyouApi
      .post(`${CENTRAL}`, {
        func: 'requestClientList',
        package_id: package_id,
      })
      .then((res) => res.data),
  register: ({ inputData }) =>
    ifyouApi
      .post(`${CENTRAL}`, {
        func: 'createNewClient',
        package_id: inputData.package_id,
        os_type: inputData.os_type,
        app_store: inputData.app_store,
        client_version: inputData.client_version,
        client_status: inputData.client_status,
        custom_url: inputData.custom_url,
        memo: inputData.memo,
      })
      .then((res) => res.data),
  update: ({ inputData }) =>
    ifyouApi
      .post(`${CENTRAL}`, {
        func: 'updateClient',
        package_id: inputData.package_id,
        os_type: inputData.os_type,
        app_store: inputData.app_store,
        client_version: inputData.client_version,
        client_status: inputData.client_status,
        custom_url: inputData.custom_url,
        memo: inputData.memo,
        client_no: inputData.client_no,
      })
      .then((res) => res.data),
  delete: ({ package_id, client_no }) =>
    ifyouApi
      .post(`${CENTRAL}`, {
        func: 'deleteClient',
        package_id: package_id,
        client_no: client_no,
      })
      .then((res) => res.data),
};

export const fetchPackageDropApi = {
  store: () =>
    ifyouApi
      .post(`${COMMON}`, { func: 'standard', code: 'app_store' })
      .then((res) => res.data),
  status: () =>
    ifyouApi
      .post(`${COMMON}`, { func: 'standard', code: 'client_status' })
      .then((res) => res.data),
};
